import { Locale } from '@synergy/models';
import fileSize from 'filesize';

export const getFileSize = (size?: number, locale?: Locale): string => {
    return fileSize(size ?? 0, { locale: locale?.replace('_', '-') });
};
